import React from 'react';
import Wagon from '../Wagon/Wagon';
import useTranslation from '../../../hooks/translation/useTranslation';
import { useBooking } from '../../../contexts/ticketBookingContext/TicketBookingContext';

const seatColumns = [
  [18],
  [17],
  [16],
  [15],
  [14],
  [13],
  [12],
  [11],
  [10],
  [9],
  [8],
  [7],
  [6],
  [5],
  [4],
  [3],
  [2],
  [1],
];

function ARMLux({
  carriageInfo,
  wagonNumber,
  chosenSeats,
  setChosenSeats,
  reserveSeat,
  unReserveSeat,
}) {
  const { isDesktop } = useBooking();
  const { trans } = useTranslation();
  return (
    <div className="wagons">
      <div className="title">
        <h1>
          <span className="font-big">{trans('wagon')}</span>
          {' '}
          {wagonNumber}
        </h1>
      </div>
      {isDesktop
        ? (
          <Wagon
            seatColumns={seatColumns}
            seats={carriageInfo?.seats}
            chosenSeats={chosenSeats}
            setChosenSeats={setChosenSeats}
            wagonNumber={wagonNumber}
            reserveSeat={reserveSeat}
            unReserveSeat={unReserveSeat}
            bottomFixed
          />
        ) : (
          <div
            style={{
              width: 291 / 2,
              height: 1250 / 2,
            }}
            className="overflow-clip flex justify-center items-center"
          >
            <div className="lg:rotate-0 rotate-90 scale-50">
              <Wagon
                seatColumns={seatColumns}
                seats={carriageInfo?.seats}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                bottomFixed
              />
            </div>
          </div>
        )}
    </div>
  );
}

export default ARMLux;
